import { render, staticRenderFns } from "./error-checkmark-component-1.vue?vue&type=template&id=51824317&lang=html&"
import script from "./error-checkmark-component-1.vue?vue&type=script&lang=js&"
export * from "./error-checkmark-component-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports